import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const ChevronDownIcon = (p: IconProps) => <Icon {...p}><path d="m6 9 6 6 6-6" /></Icon>
